/** @type {ActionType} */
export const pbr_ios_deep_link_clicked = 'pbr_ios_deep_link_clicked';
